import { autoinject } from 'aurelia-dependency-injection';

@autoinject
export class NotFound {

}